import React from "react";
import dayjs from "dayjs";

function Redirect(props) {
  const onMouseEnterButton = (e) => {
    if (!e.target) { return }
    if (e.target.disabled === true) { return }

    e.target.style.color = props.config?.customDesign?.messageRedirectButtonMouseEnter.color ?? "#f8f5f5";
    e.target.style.backgroundColor = props.config?.customDesign?.messageRedirectButtonMouseEnter.background ?? "#2935dd";
  }

  const onMouseLeaveButton = (e) => {
    if (!e.target) { return }

    e.target.style.color = props.config?.customDesign?.messageRedirectButtonMouseLeave.color ?? "#0092ed";
    e.target.style.backgroundColor = props.config?.customDesign?.messageRedirectButtonMouseLeave.background ?? "#fff";
  }

  const messageContainerClassName = () => {
    return props.config.autoFullScreen ? "s360-message-cotainer-received-fs" : "s360-message-cotainer-received";
  }

  const messageBoxStyle = () => {
    return {
      marginLeft: '15px',
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "#0092ed",
      borderRadius: 20,
      color: "#0092ed",
      backgroundColor: "#fff",
      ...props.config?.customDesign?.messageRedirectBox
    }
  }

  const messageTimeStyle = () => {
    let config = props.config;
    return config?.customDesign?.messageRedirectTime;
  }


  const onMessageSend = (e) => {
    onMouseLeaveButton(e);

    let n = document.getElementsByClassName("btn btn-chat");

    for(let i=0; i < n.length; i++){
      n[i].disabled = true;
      onMouseLeaveButton(n[i]);
    }

    // props.actions.sendMessage(props.entry.keyword);
    props.actions.sendMessageWithCode(props.entry.keyword, props.entry.text);
    const link = document.createElement('a');
    link.href = props.entry.url;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    link.remove();

  }

  const isActiveConversation = () => {
    let isClosed = (props.activeConversation && props.activeConversation.active != null && props.activeConversation.active !== undefined && props.activeConversation.active === false) || props.isConversationClosed;
    return !isClosed;
  }

  const text = (props.entry && props.entry.text) || "";
  // if (props.entry && props.entry.keyword) {
  //     text = text;
  // }

  return (
    <div className={messageContainerClassName()}>
      <button disabled={props.disabled} className="btn btn-chat btn-check btn-redirect"  style={messageBoxStyle()}  onMouseEnter={onMouseEnterButton} onMouseLeave={onMouseLeaveButton}  {...(isActiveConversation() && { onClick:onMessageSend })}>
        {text}
        <br />
      </button>
      {props.isLastEntry && props.sentTimestamp && <div className="s360-message-time-received" style={messageTimeStyle()}>
        {dayjs.unix(Math.trunc(props.sentTimestamp/1000)).format("DD MMM h:mm a")}
      </div>}
    </div>
  )
}

export default Redirect;
